import styled from "styled-components";
import { Button } from "@similarweb/ui-components";

export const FiltersNewContainer = styled.div`
    padding-bottom: 8px;
`;
export const FiltersNewContent = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

const FiltersNewFilters = styled.div`
    flex-grow: 1;
    flex-wrap: wrap;
    max-width: 872px;
    display: flex;
    align-items: center;
    @media (max-width: 1291px) {
        max-width: 761px;
    }
`;

const FiltersNewButtons = styled.div`
    flex-grow: 1;
    min-width: 180px;
    display: flex;
    align-items: flex-end;
    padding-bottom: 33px;
    flex-direction: row-reverse;
`;
const ClearAllButton = styled(Button)`
    margin-right: 4px;
`;
const FilterItem = styled.div`
    /* override inline style */
    width: auto !important;
    display: inline-flex;
`;
export const FilterItemChipdown = styled(FilterItem)`
    margin: 0 8px 8px 0;
`;
const FilterItemCheckbox = styled(FilterItem)`
    margin: 0 14px 8px 0;
`;

export const FilterItemButton = styled(FilterItemChipdown)``;
